import { ProductServicePageBlock } from '@/payload-types';
import { Fragment } from 'react';
import { ProductCallToAction } from './ProductCallToAction';
import { LocalityBanner } from './LocalityBanner';
import { LocalityCallToAction } from './LocalityCallToAction';
import Services from '../ProductService/Card/Services';

const blockComponents = {
  hero: LocalityBanner,
  product: Services,
  projects: null,
  gallery: null,
  faq: null,
  content: ProductCallToAction,
  team: null,
  formBlock: null,
  cta: LocalityCallToAction,
  mediaBlock: null,
  features: null,
  timeline: null,
  featuredBlogs: null,
  preview: Services,
};

const RenderLocalityBlock: React.FC<ProductServicePageBlock> = (props) => {
  const { content } = props;

  const hasBlocks = content && Array.isArray(content) && content.length > 0;

  if (hasBlocks) {
    return (
      <Fragment>
        {content.map((block, index) => {
          const { blockType } = block;

          if (blockType && blockType in blockComponents) {
            const Block = blockComponents[blockType];

            if (Block) {
              return (
                <div key={index}>
                  {/* @ts-expect-error there may be some mismatch between the expected types here */}
                  <Block {...block} />
                </div>
              );
            }
          }
          return null;
        })}
      </Fragment>
    );
  }

  return null;
};

export { RenderLocalityBlock };
